import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import '../../styles/glass.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isServicesOpen, setIsServicesOpen] = useState(false);

  const services = [
    { label: 'Amazon Account Management', href: '/services/account-management' },
    { label: 'Amazon PPC Campaign Management', href: '/services/ppc-management' },
    { label: 'Amazon Keywords SEO', href: '/services/keyword-seo' },
    { label: 'Amazon Graphic Services', href: '/services/analytics' },
    { label: 'Amazon Product Research', href: '/services/product-research' },
    { label: 'Amazon Brand Registration', href: '/services/brand-registration' },
    { label: 'Amazon Catalogue Management', href: '/services/catalogue-management' },
    { label: 'Amazon Listing Optimization', href: '/services/listing-optimization' },
    { label: 'Amazon Trouble Shootings', href: '/services/troubleshooting' }
  ];

  const navItems = [
    { label: 'ABOUT US', href: '/about' },
    {
      label: 'SERVICES',
      href: '/services',
      hasDropdown: true,
      dropdownItems: services
    },
    { label: 'CASE STUDIES', href: '/case-studies' },
    { label: 'PORTFOLIO', href: '/portfolio' },
    { label: 'BLOG', href: '/blog' },
  ];

  const handleNavigation = () => {
    setIsOpen(false);
    setIsServicesOpen(false);
    window.scrollTo(0, 0);
  };

  return (
    <nav className="fixed w-full z-50 backdrop-blur-md bg-cream/80 dark:bg-black/80 transition-colors duration-300">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center" onClick={() => window.scrollTo(0, 0)}>
            <img
              src="/images/logo-black-1.png"
              alt="Trioperspective"
              className="h-8 block dark:hidden"
            />
            <img
              src="/images/logo-white-1.png"
              alt="Trioperspective"
              className="h-8 hidden dark:block"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            {navItems.map((item) => (
              <div key={item.label} className="relative group">
                <Link
                  to={item.href}
                  className="text-sm font-semibold text-black dark:text-white hover:text-primary dark:hover:text-primary transition-colors duration-300 flex items-center"
                  onClick={() => item.hasDropdown ? null : handleNavigation()}
                >
                  {item.label}
                  {item.hasDropdown && (
                    <svg
                      className="w-4 h-4 ml-1 transform group-hover:rotate-180 transition-transform duration-300"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  )}
                </Link>
                {item.hasDropdown && (
                  <div className="absolute left-0 mt-2 w-72 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform">
                    <div className="bg-black rounded-xl shadow-xl px-2 py-1 backdrop-blur-md border border-white/10">
                      {item.dropdownItems.map((dropdownItem) => (
                        <Link
                          key={dropdownItem.label}
                          to={dropdownItem.href}
                          className="block px-4 py-2 my-1 rounded-lg text-sm text-white hover:text-primary hover:bg-white transition-colors duration-300"
                          onClick={handleNavigation}
                        >
                          {dropdownItem.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            ))}
            <Link to="/contact"><Button>GET A FREE AUDIT</Button></Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="lg:hidden p-2 rounded-md text-black dark:text-white hover:text-primary dark:hover:text-primary"
          >
            <svg
              className="h-6 w-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="lg:hidden py-4 border-t border-black/10 dark:border-white/10">
            <div className="flex flex-col space-y-4">
              {navItems.map((item) => (
                <div key={item.label}>
                  {item.hasDropdown ? (
                    <div>
                      <button
                        onClick={() => setIsServicesOpen(!isServicesOpen)}
                        className="w-full text-left text-sm font-semibold text-black dark:text-white hover:text-primary dark:hover:text-primary transition-colors duration-300 flex items-center justify-between"
                      >
                        {item.label}
                        <svg
                          className={`w-4 h-4 ml-1 transform transition-transform duration-300 ${isServicesOpen ? 'rotate-180' : ''}`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>
                      {isServicesOpen && (
                        <div className="mt-2 ml-4 space-y-2">
                          {item.dropdownItems.map((dropdownItem) => (
                            <Link
                              key={dropdownItem.label}
                              to={dropdownItem.href}
                              className="block text-sm text-black/60 dark:text-white/60 hover:text-primary dark:hover:text-primary transition-colors duration-300"
                              onClick={handleNavigation}
                            >
                              {dropdownItem.label}
                            </Link>
                          ))}
                        </div>
                      )}
                    </div>
                  ) : (
                    <Link
                      to={item.href}
                      className="block text-sm font-semibold text-black dark:text-white hover:text-primary dark:hover:text-primary transition-colors duration-300"
                      onClick={handleNavigation}
                    >
                      {item.label}
                    </Link>
                  )}
                </div>
              ))}
              <Button onClick={handleNavigation} className="w-full">GET A FREE AUDIT</Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;
